import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import { Sun, Moon } from "lucide-react";

const MetricBox = ({ label, value, unit, theme = "orange" }) => (
  <div className={`pko-box pko-box-${theme}`}>
    <div className="pko-box-label">{label}</div>
    <div className="pko-box-value">{value ?? "—"}</div>
    {unit && <div className={`pko-box-unit pko-unit-${theme}`}>{unit}</div>}
  </div>
);

const PackingOverview = ({ data = {}, isLoading = false }) => (
  <div className="po-wrapper">

    {/* PACKING DAY — orange theme */}
    <DashboardCard
      title={<><Sun size={15} color="#ee7225" style={{ marginRight: 6, flexShrink: 0 }} /> PACKING <span className="pko-shift-label">Day</span></>}
    >
      <div className="pko-grid-5">
        <MetricBox label="TOTAL BOXES"  value={data?.day?.cheeks2  ?? 280}  theme="orange" />
        <MetricBox label="CHEEKS"  value={data?.day?.cheeks2  ?? 60} unit="10 LB" theme="orange" />
        <MetricBox label="CHEEKS"  value={data?.day?.cheeks ?? 50}  unit="20 LB" theme="orange" />
        <MetricBox label="STRIPS"  value={data?.day?.strips ?? 100 }  unit="20 LB" theme="orange" />
        <MetricBox label="PASTING" value={data?.day?.pasting ?? 70} unit="20 LB" theme="orange" />
      </div>
    </DashboardCard>

    {/* PACKING TURN 2 — blue/purple theme */}
    <DashboardCard
      title={<><Moon size={15} color="#5b6abf" style={{ marginRight: 6, flexShrink: 0 }} /> PACKING <span className="pko-shift-label pko-shift-blue">Turn 2</span></>}
    >
      <div className="pko-turn2-layout">
        {/* Left: Total Boxes tall cell */}
        <div className="pko-total-cell pko-box-blue">
          <div className="pko-box-label">TOTAL BOXES</div>
          <div className="pko-box-value">{data?.turn2?.total_boxes ?? "410"}</div>
        </div>
        {/* Right: 4-col grid */}
        <div className="pko-grid-right">
          <MetricBox label="PRIME CHEEK BOXES"   value={data?.turn2?.prime_cheek_boxes ?? 50}   unit="10 LB" theme="blue" />
          <MetricBox label="PRIME CHEEK BOXES"   value={data?.turn2?.prime_cheek_boxes2 ?? 70}  unit="20 LB" theme="blue" />
          <MetricBox label="PRIME STRIP BOXES"   value={data?.turn2?.prime_strip_boxes ?? 80}   unit="20 LB" theme="blue" />
          <MetricBox label="SECONDS CHEEK BOXES" value={data?.turn2?.seconds_cheek_boxes ?? 30} unit="20 LB" theme="blue" />
          <MetricBox label="SECONDS STRIP BOXES" value={data?.turn2?.seconds_strip_boxes ?? 20} unit="20 LB" theme="blue" />
          <MetricBox label="TAPITAS BOXES"        value={data?.turn2?.tapitas_boxes ?? 100}       unit="20 LB" theme="blue" />
          <MetricBox label="PIECES BOXES"         value={data?.turn2?.pieces_boxes ?? 60}        unit="20 LB" theme="blue" />
        </div>
      </div>
    </DashboardCard>

  </div>
);

export default PackingOverview;
